import { render, staticRenderFns } from "./NewCustomersWidget.vue?vue&type=template&id=4fa40ac4&scoped=true"
import script from "./NewCustomersWidget.vue?vue&type=script&lang=ts"
export * from "./NewCustomersWidget.vue?vue&type=script&lang=ts"
import style0 from "./NewCustomersWidget.vue?vue&type=style&index=0&id=4fa40ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa40ac4",
  null
  
)

export default component.exports